<template>
    <div>
        <h1 class="u-m0">
            <span class="u-screenreader">
                Baza podataka o budžetskom sufinansiranju medijskih sadržaja u Srbiji
            </span>
        </h1>
        <h2 class="h1">О бази</h2>
        <p>
            База је унапређивана више година и прошла је пут од помоћног алата до јавне базе која кориснику бесплатно
            омогућава увид у податке и документа и њихово укрштање.
        </p>
        <p>
            Прва верзија базе креирана је и коришћена као интерни алат у оквиру пројекта „Бити или не бити за медијску
            реформу у Србији“ где су УНС и партнерске организације НУНС, НДНВ, Локал Прес и АНЕМ пратили процес
            пројектног суфинансирања медија на свим нивоима власти. Свака организација надзирала је и уносила у базу у
            пројектном периоду податке за по <a
                href="http://uns.org.rs/sta-radimo/projekti/32155/pracenje-projektnog-sufinansiranja-medija.html"
                target="_blank" rel="noopener noreferrer">33 или 34 локалне самоуправе (укупно 166)</a>, док је УНС
            пратио и уносио и податке конкурса Покрајинског секретаријата за културу, јавно информисање и односе с
            верским заједницама и Министарства културе и информисања.
        </p>
        <p>
            Пројекат „Бити или не бити за медијску реформу у Србији“ је трајао од 1. априла 2015. године до 31. марта
            2016. године, с циљем праћења медијске реформе која је наступила усвајањем закона 2014. године по којима се
            држава обавезала да изађе из власништва у медијима и медијске садржаје од јавног значаја суфинансира на
            конкурсима.
        </p>

        <p>
            По окончању овог пројекта, који су подржале Амбасада Велике Британије и Амбасада Аустралије, УНС је наставио
            да развија базу.
        </p>

        <p>
            Сајт <a href="https://finansiranjemedija.rs/">www.finansiranjemedija.rs</a> израдио је УНС у оквиру пројекта
            "Претражи ме - јавна база пројектног суфинансирања медијских садржаја од јавног значаја" који је подржало
            Министарство културе и информисања на конкурсу 2017. године.
        </p>

        <p>
            Пројекат је трајао од јуна 2017. до краја марта 2018. године. У овом периоду, партнери на пројекту НУНС,
            НДНВ, Локал Прес и АНЕМ су, уз УНС, пратили конкурсни процес у локалним самоуправама и достављали податке
            које је УНС уносио у базу.
        </p>
        <div class="centerStats"><br/>
            <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />
            <div class="chart-wrapper">
                <canvas ref="yearlyChart"></canvas>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { baseUrl } from '../env'    
import LoadingModal from '../components/LoadingModal.vue'

Chart.register(ChartDataLabels)

const yearlyChart = ref(null)
const loading = ref(true)
const loadingLabel = ref('Учитавање статистике...')

function formatDate(day, month, year) {
    return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}.`
}

async function fetchStat(url) {
    try {
        const res = await axios.get(`${baseUrl}${url}`)
        const data = res.data
        return data.value || data.count || (Array.isArray(data) ? data.length : 0) || data
    } catch (e) {
        console.error('Greška pri fetchovanju:', e)
        return 0
    }
}

onMounted(async () => {
    try {
        const d = new Date()
        const startYear = 2015
        const endYear = d.getFullYear()
        const yearlyTotals = []

        for (let year = startYear; year <= endYear; year++) {
            const from = formatDate(1, 1, year)
            const to = formatDate(31, 12, year)
            const value = await fetchStat(`/query/7/${from}/${to}`)
            yearlyTotals.push(Number(value) || 0)
        }

        
        if (yearlyChart.value) {
        const ctx = yearlyChart.value.getContext('2d')
        yearlyChart.value = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: Array.from({ length: endYear - startYear + 1 }, (_, i) => `${startYear + i}`),
                datasets: [{
                    label: 'Додељена средства по години (РСД)',
                    data: yearlyTotals,
                    backgroundColor: 'rgba(75,192,192,0.2)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    datalabels: {
                        formatter: val => `${(val / 1_000_000).toFixed(0)}M`
                    }
                }
            }
        })
        }
        else {
            console.error('Грешка: yearlyChart')
        }
       
        loading.value = false
    } catch (e) {
        console.error('Statistika greška:', e)
        loading.value = false
    }
})
</script>

<style scoped>
.loading-overlay {
    position: relative;
    top: 10%;
    left: 50%;
    width: 10%;
    height: 10%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.chart-wrapper {
    max-width: 100%;
    width: 100%;
    height: 300px;
    position: relative;
}

canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
